import { SuccessModal } from '@/src/components/Modals/modal'
import { BulkUploadModal } from '@/src/components/common/Modal/BulkUploadModal'
import { AdminHelpGuideModal } from '@/src/pages/Admin/VideoGuide/Modal/AdminHelpGuideModal'
import Approval from '@/src/pages/Doctor/Encounter/Manage Orders/Modals/Procedure/ConsentForm/Approval'
import AddVital from '@/src/pages/Nurse/NurseEcounter/Intake/vitals/modal/AddNurseVital'
import { AddTemplate } from '@/src/pages/Receptionist/Form/AddTemplate'
import {
  AppoointmetDetails,
  CalendarDetails,
  CancelAppointment,
  CreateAppointment,
  RemoveAppointment
} from '@admin/Appointment/Modal'
import AddArchiveRecord from '@admin/Archives/Modal/AddArchiveRecord'
import FileDetails from '@admin/Archives/Modal/FileDetails'
import ScannedDocumentDetails from '@admin/Archives/Modal/ScannedDocumentDetails'
import UploadScannedDocument from '@admin/Archives/Modal/UploadScannedDocument'
import { AddItem, EditItem, RemoveItem } from '@admin/Billing/Modals'
import { AddChargeItem } from '@admin/ChargeItem/AddChargeItem'
import DrugModal from '@admin/Drug/Modal/Addedication'
import RemoveDrug from '@admin/Drug/Modal/RemoveDrug'
import AddFacility from '@admin/Facilities/AddFacility'
import RemoveFacility from '@admin/Facilities/RemoveFacility'
import { DeleteForm } from '@admin/Forms/Modals/DeleteForm'
import { NewForm } from '@admin/Forms/Modals/NewForm'
import { SyntaxCode } from '@admin/Forms/Modals/SyntaxCode'
import { AddHmo, AddTariff, EditTariff, NewPlan, RemoveHmo, RemovePlan, RemoveTariff } from '@admin/HMO/Modal'
import HmoBulkMapModal from '@/src/pages/Admin/HMO/HmoBulkMapModal'
import { AddImaging, EditImaging, ImagingPrice, RemoveImaging } from '@admin/Imaging/Modal'
import { AddLaboratory, EditLaboratory, EditPricing, RemoveLaboratory } from '@admin/Laboratory/Modal'
import PatientBulkMapModal from '@/src/pages/Admin/Patient/PatientBulkMapModal'
import { AddPatient, RemovePatient, UpdatePatient, ViewPatientModal } from '@admin/Patient/modals'
import RemoveProcedure from '@admin/Procedure/Modal/RemoveProcedure'
import { AddStaff } from '@admin/Staff/modals/AddStaff'
import { AddBed, BedDetails, EditBed, RemoveBed } from '@admin/Units/Bed/Modals'
import { AssigneBed } from '@admin/Units/Bed/Modals/AssigneBed'
import { RequestDetails } from '@admin/Units/Bed/Modals/RequestDetails'
import { AddUnit, EditUnit, RemoveUnit } from '@admin/Units/Modals'
import { AddRoom, EditRoom, RemoveRoom } from '@admin/Units/Room/modals'
import { ADMIN_MODAL_TYPE } from '@data'
import { Reassign } from '@doctor/AssignedPatient/Modal/Reassign'
import Template from '@doctor/Encounter/Manage Orders/Modals/Procedure/ConsentForm/Template'
import { Upload } from '@doctor/Encounter/Manage Orders/Modals/Procedure/Upload'
import { Fragment } from 'react'
import { useModalStore } from './modalstore'

const Modals = [
  { component: AddStaff, value: ADMIN_MODAL_TYPE.ADD_STAFF },
  { component: AddHmo, value: ADMIN_MODAL_TYPE.ADD_HMO_MODAL },
  { component: NewPlan, value: ADMIN_MODAL_TYPE.ADD_HMO_PLAN },
  { component: RemovePlan, value: ADMIN_MODAL_TYPE.REMOVE_PLAN },
  { component: AddTariff, value: ADMIN_MODAL_TYPE.ADD_TARIFF },
  { component: EditTariff, value: ADMIN_MODAL_TYPE.EDIT_TARIFF },
  { component: RemoveTariff, value: ADMIN_MODAL_TYPE.REMOVE_TARIFF },
  { component: RemoveProcedure, value: ADMIN_MODAL_TYPE.REMOVE_PROCEDURE_MODAL },
  { component: RemoveDrug, value: ADMIN_MODAL_TYPE.REMOVE_DRUG_MODAL },
  { component: RemoveHmo, value: ADMIN_MODAL_TYPE.REMOVE_HMO_MODAL },
  { component: AddLaboratory, value: ADMIN_MODAL_TYPE.ADD_LABORATORY_MODAL },
  { component: EditLaboratory, value: ADMIN_MODAL_TYPE.EDIT_LABORATORY_MODAL },
  { component: EditPricing, value: ADMIN_MODAL_TYPE.EDIT_LAB_PRICE_MODAL },
  { component: RemoveLaboratory, value: ADMIN_MODAL_TYPE.REMOVE_LABORATORY_MODAL },
  { component: AddImaging, value: ADMIN_MODAL_TYPE.ADD_IMAGING_MODAL },
  { component: EditImaging, value: ADMIN_MODAL_TYPE.EDIT_IMAGING_MODAL },
  { component: ImagingPrice, value: ADMIN_MODAL_TYPE.EDIT_IMAGING_PRICE_MODAL },
  { component: RemoveImaging, value: ADMIN_MODAL_TYPE.REMOVE_IMAGING_MODAL },
  { component: NewForm, value: ADMIN_MODAL_TYPE.ADD_CONSENT_FORM },
  { component: AddUnit, value: ADMIN_MODAL_TYPE.ADD_UNIT_MODAL },
  { component: EditUnit, value: ADMIN_MODAL_TYPE.EDIT_UNIT_MODAL },
  { component: RemoveUnit, value: ADMIN_MODAL_TYPE.DELETE_UNIT_MODAL },
  { component: AddBed, value: ADMIN_MODAL_TYPE.ADD_BED_MODAL },
  { component: EditBed, value: ADMIN_MODAL_TYPE.EDIT_BED_MODAL },
  { component: RemoveBed, value: ADMIN_MODAL_TYPE.REMOVE_BED_MODAL },
  { component: BedDetails, value: ADMIN_MODAL_TYPE.BED_DETAIL_MODAL },
  { component: AssigneBed, value: ADMIN_MODAL_TYPE.ASSIGN_BED_MODAL },
  { component: RequestDetails, value: ADMIN_MODAL_TYPE.REQUEST_DETAIL_MODAL },
  { component: AddRoom, value: ADMIN_MODAL_TYPE.ADD_ROOM_MODAL },
  { component: EditRoom, value: ADMIN_MODAL_TYPE.EDIT_ROOM_MODAL },
  { component: RemoveRoom, value: ADMIN_MODAL_TYPE.REMOVE_ROOM_MODAL },
  { component: DeleteForm, value: ADMIN_MODAL_TYPE.DELETE_CONSENT_FORM },
  { component: SyntaxCode, value: ADMIN_MODAL_TYPE.SYNTAX_CODE },
  { component: AddItem, value: ADMIN_MODAL_TYPE.ADD_ITEM },
  { component: EditItem, value: ADMIN_MODAL_TYPE.EDIT_ITEM },
  { component: RemoveItem, value: ADMIN_MODAL_TYPE.REMOVE_ITEM },
  { component: Reassign, value: ADMIN_MODAL_TYPE.ASSIGN_PATIENT },
  { component: ViewPatientModal, value: ADMIN_MODAL_TYPE.VIEW_PATIENT },
  { component: AddPatient, value: ADMIN_MODAL_TYPE.ADD_PATIENT },
  { component: UpdatePatient, value: ADMIN_MODAL_TYPE.EDIT_PATIENT },
  { component: RemovePatient, value: ADMIN_MODAL_TYPE.REMOVE_PATIENT },
  { component: SuccessModal, value: ADMIN_MODAL_TYPE.SUCCESS_MODAL },
  { component: Upload, value: ADMIN_MODAL_TYPE.UPLOAD_MODAL },
  { component: Template, value: ADMIN_MODAL_TYPE.CONSENT_FORM },
  { component: Approval, value: ADMIN_MODAL_TYPE.PROCEDURE_APPROVAL },
  { component: AddTemplate, value: ADMIN_MODAL_TYPE.ADD_TEMPLATE },
  { component: AddVital, value: ADMIN_MODAL_TYPE.ADD_VITAL },
  { component: AddChargeItem, value: ADMIN_MODAL_TYPE.ADD_CHARGE_ITEM },
  { component: DrugModal, value: ADMIN_MODAL_TYPE.DRUG_MODAL },
  { component: CreateAppointment, value: ADMIN_MODAL_TYPE.CREATE_APPOINTMENT },
  { component: CalendarDetails, value: ADMIN_MODAL_TYPE.CALENDAR_DETAILS },
  { component: RemoveAppointment, value: ADMIN_MODAL_TYPE.REMOVE_APPOINTMENT },
  { component: CancelAppointment, value: ADMIN_MODAL_TYPE.CANCEL_APPOINTMENT },
  { component: AppoointmetDetails, value: ADMIN_MODAL_TYPE.APPOINTMENT_DETAILS },
  { component: AdminHelpGuideModal, value: ADMIN_MODAL_TYPE.ADMIN_HELP_GUIDE },
  { component: BulkUploadModal, value: ADMIN_MODAL_TYPE.BULK_FILE_UPLOAD },
  { component: HmoBulkMapModal, value: ADMIN_MODAL_TYPE.HMO_BULK_MAP_MODAL },
  { component: PatientBulkMapModal, value: ADMIN_MODAL_TYPE.PATIENT_BULK_MAP_MODAL },
  { component: AddFacility, value: ADMIN_MODAL_TYPE.FACILITY_MODAL },
  { component: RemoveFacility, value: ADMIN_MODAL_TYPE.REMOVE_FACILITY_MODAL },
  { component: AddArchiveRecord, value: ADMIN_MODAL_TYPE.ADD_ARCHIVE_RECORD },
  { component: FileDetails, value: ADMIN_MODAL_TYPE.ARCHIVE_FILE_DETAILS },
  { component: UploadScannedDocument, value: ADMIN_MODAL_TYPE.UPLOAD_ARCHIVE_DOCUMENT },
  { component: ScannedDocumentDetails, value: ADMIN_MODAL_TYPE.ARCHIVE_DOCUMENT_DETAILS }
]

export const AdminModal = () => {
  const { activeModal, closeModal } = useModalStore()

  return (
    <>
      {Modals?.map(({ component: Component, value }) => {
        const activeEntry = activeModal.find(({ modal }) => modal === value)
        const modalProps = (activeEntry?.modalProps as Record<string, any>) || {}
        const reset = modalProps.reset as (() => void) | undefined
        const isOpen = activeEntry != null

        return (
          <Fragment key={value}>
            {isOpen && (
              <Component
                isOpen={isOpen}
                key={value}
                onClose={() => {
                  closeModal(value, reset)
                }}
                {...modalProps}
              />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
